import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as externalInstitutions from '../../../../external-institutions'
import * as employee from '../employee'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: employee.RESOURCE.payload.dimension.partialId,
      partialId: employee.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Institution that employs this employee',
    isOptional: false,
    name: 'Institution',
    partialId: PartialId.Standard.create('institution'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        externalInstitutions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
